import React from "react";

export function Timeline({ current, duration, onSeek }) {
  const handleSeek = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const time = x * duration;
    onSeek(time);
  };

  const progress = duration > 0 ? (current / duration) * 100 : 0;

  return (
    <div 
      className="cam360-timeline"
      style={{
        position: 'absolute',
        bottom: '60px',
        left: '16px',
        right: '16px',
        height: '4px',
        background: 'rgba(255,255,255,0.2)',
        borderRadius: '2px',
        cursor: 'pointer'
      }}
      onClick={handleSeek}
    >
      <div 
        style={{
          width: `${progress}%`,
          height: '100%',
          background: '#ff0000',
          borderRadius: '2px',
          pointerEvents: 'none'
        }}
      />
      <div style={{
        position: 'absolute',
        top: '8px',
        left: '0',
        color: 'white',
        fontSize: '12px'
      }}>
        {Math.floor(current)}s / {Math.floor(duration)}s
      </div>
    </div>
  );
}
